import React from "react";
import { thisBaseURL } from "../../utils/helper.js";

function ProductUses({foodAnswers}){
	let defaultSlug = foodAnswers.answerKeyValues["food_slug"];
	let humanFoodUseSourceRef = foodAnswers.answerKeyValues['human_food_uses_of_the_commodity_sources'];
	let humanFoodUseYear = foodAnswers.answerKeyValues['human_food_uses_of_the_commodity_year'];
	
	let nonhumanFoodUseSourceRef = foodAnswers.answerKeyValues['non_food_uses_of_the_commodity_sources'];
	let nonhumanFoodUseNotes = foodAnswers.answerKeyValues['non_food_uses_of_the_commodity_notes'];
	let nonhumanFoodUseYear = foodAnswers.answerKeyValues['non_food_uses_of_the_commodity_year'];
	
	return (
		<div className="question-grouping" id="product_uses">
			<h2>Product Uses</h2>
			<h3>
				Food Uses
				{humanFoodUseYear ? 
					<small>&nbsp;({humanFoodUseYear})</small>
				: ""}
				{humanFoodUseSourceRef && humanFoodUseSourceRef > 0 ? 
				<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+humanFoodUseSourceRef}>{humanFoodUseSourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['human_food_uses_of_the_commodity']}</p>

			<h3>
				Non-Food Uses
				{nonhumanFoodUseYear ? 
					<small>&nbsp;({nonhumanFoodUseYear})</small>
				: ""}
				{nonhumanFoodUseSourceRef && nonhumanFoodUseSourceRef > 0 ? 
				<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+nonhumanFoodUseSourceRef}>{nonhumanFoodUseSourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['non_food_uses_of_the_commodity']}</p>
			{nonhumanFoodUseNotes  ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{nonhumanFoodUseNotes}</em>
				</p>
			: ""}
		</div>
	);
	
}
export default ProductUses;